module.exports = __webpack_public_path__ + "static/img/town.893b7ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/town.jpg
// module id = uCm8
// module chunks = 1